// extracted by mini-css-extract-plugin
export default {"container":"PollContentList_container__OFJ5f"};